"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PostCard_1 = __importDefault(require("../../PostCard/PostCard"));
var lodash_1 = require("lodash");
var react_router_dom_1 = require("react-router-dom");
var ResultsListConfig_1 = __importDefault(require("../../../constants/ResultsListConfig"));
var CardSkeleton_1 = __importDefault(require("../../CardSkeleton/CardSkeleton"));
var DeactivationModal_1 = __importDefault(require("../../Modals/DeactivationModal"));
var myAnnouncementsSlice_1 = require("../../../features/myAnnouncements/myAnnouncementsSlice");
var react_redux_1 = require("react-redux");
var globalSlice_1 = require("../../../features/global/globalSlice");
var react_i18next_1 = require("react-i18next");
var PostListLayout = function (_a) {
    var posts = _a.posts, layout = _a.layout, onUpdateToTop = _a.onUpdateToTop, handleOpenEditPage = _a.handleOpenEditPage, onRemove = _a.onRemove, onAddBookmark = _a.onAddBookmark, onRemoveBookmark = _a.onRemoveBookmark, onStatistic = _a.onStatistic, hideBookmarks = _a.hideBookmarks, handleOpenPostPreviewBySlug = _a.handleOpenPostPreviewBySlug, previewUrl = _a.previewUrl;
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation('common').t;
    var _b = react_1.useState(false), isOpenDeactivationModal = _b[0], setIsOpenDeactivationModal = _b[1];
    var _c = react_1.useState(false), isOpenCheckoutModal = _c[0], setIsOpenCheckoutModal = _c[1];
    var _d = react_1.useState(), currentPostId = _d[0], setCurrentPostId = _d[1];
    var openPostPreview = function (id, slug) {
        if (lodash_1.isFunction(handleOpenPostPreviewBySlug)) {
            handleOpenPostPreviewBySlug(slug);
        }
        else {
            history.push(location.pathname + "/preview/" + id);
        }
    };
    var handleOpenDeactivationModal = react_1.useCallback(function (postId) {
        setIsOpenDeactivationModal(!isOpenDeactivationModal);
        setCurrentPostId(postId);
    }, [isOpenDeactivationModal]);
    var handleOpenCheckoutModal = react_1.useCallback(function (postId) {
        setIsOpenCheckoutModal(!isOpenCheckoutModal);
        setCurrentPostId(postId);
    }, [isOpenCheckoutModal]);
    var handleActivatePost = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(myAnnouncementsSlice_1.activatePost(id))];
                case 1:
                    _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('MY_ANNOUNCEMENT.ACTIVATE_STATUS'),
                        appearance: 'success',
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    return (posts === null || posts === void 0 ? void 0 : posts.data) ? (react_1.default.createElement(react_1.default.Fragment, null,
        isOpenDeactivationModal && (react_1.default.createElement(DeactivationModal_1.default, { postId: currentPostId, handleOpenDeactivationModal: handleOpenDeactivationModal })),
        posts.data.map(function (post, index) { return (react_1.default.createElement(PostCard_1.default, { displayType: layout, key: index, post: post, onUpdateToTop: onUpdateToTop, handleOpenEditPage: handleOpenEditPage, onRemove: onRemove, openPostPreview: openPostPreview, handleOpenDeactivationModal: handleOpenDeactivationModal, onAddBookmark: onAddBookmark, onRemoveBookmark: onRemoveBookmark, activatePost: handleActivatePost, onStatistic: onStatistic, hideBookmarks: hideBookmarks, previewUrl: previewUrl })); }))) : (react_1.default.createElement(react_1.default.Fragment, null, Array(ResultsListConfig_1.default.SKELETON_COUNT)
        .fill(0)
        .map(function (i, index) { return (react_1.default.createElement(CardSkeleton_1.default, { className: layout, key: index })); })));
};
exports.default = PostListLayout;
